export default __webpack_public_path__ + "static/media/rupee_blue.b72d6be8.svg";